<template>
  <div class="d-flex flex-column h-100 w-100 align-start justify-start">
    <div class="d-flex flex-column justify-start">
      <p
        class="ma-0 pa-0 text-truncate font-size-12 font-weight-500 blue-grey--text text--darken-3 mb-3"
        style="line-height: 14px;"
      >
        {{ title }}
      </p>
      <div class="d-flex mb-2 align-center">
        <p
          class="ma-0 pa-0 blue-grey--text text--darken-3 font-size-24 font-weight-700 me-3"
          style="line-height: 24px;"
        >
          {{ total.text }}
        </p>
        <PercentageChangeChip
          v-if="total.value !== 0 || totalLastPeriod !== 0"
          :percentageChange="percentageChange"
        />
      </div>

      <p
        class="ma-0 pa-0 font-size-10 font-weight-400 blue-grey--text text--darken-1 mb-2"
        style="line-height: 10px;"
      >
        <span class="font-weight-600">
          {{ difference.value }}
        </span>
        {{ difference.text }}
      </p>
    </div>
    <div class="d-flex align-center" v-if="showComparation">
      <CompareData
        :type="type"
        :globalData="globalAverage"
        :compareDifference="compareDifference"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompareData from './CompareData.vue'
import PercentageChangeChip from './PercentageChangeChip.vue'

export default {
  name: 'Trend',

  components: { CompareData, PercentageChangeChip },

  props: {
    type: String,
    globalAverage: Number,
    title: String,
    percentageChange: Number,
    total: Object,
    totalLastPeriod: Number,
    showComparation: Boolean,
  },

  computed: {
    ...mapGetters(['language']),

    compareDifference() {
      return this.total.value - this.globalAverage
    },

    difference() {
      const diffNumber = this.total.value - this.totalLastPeriod
      const diffText = `${diffNumber > 0 ? '+' : ''}${diffNumber.toLocaleString(
        this.language
      )}`
      return {
        number: diffNumber,
        value: diffText,
        text: this.$t('insights.entity_created_in_this_period'),
      }
    },
  },
}
</script>
